(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amb-availability"] && !Shopify.designMode) return;
  try {
    (() => {
    const controls = new Set();
    let latestCart;
    let revision = 0;
    let pendingRefresh;

    function updateCart(cart) {
      if (!Array.isArray(cart?.items)) return;
      latestCart = cart;
      revision += 1;
      controls.forEach((control) => control.update());
    }

    async function refreshCart() {
      if (!controls.size || pendingRefresh) return pendingRefresh;
      const startedAt = revision;
      pendingRefresh = (async () => {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
          if (response.ok) {
            const cart = await response.json();
            if (revision === startedAt) updateCart(cart);
          }
        } catch {} finally {
          pendingRefresh = undefined;
        }
      })();
      return pendingRefresh;
    }

    class AmbAvailability extends HTMLElement {
      connectedCallback() {
        controls.add(this);
        this.abortController = new AbortController();
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.config = JSON.parse(this.querySelector('[data-availability]').textContent);
          this.message = this.querySelector('[data-message]');
          this.form = document.getElementById(this.dataset.formId);
          const signal = this.abortController.signal;
          const onInput = (event) => {
            if (event.target.form === this.form && ['quantity', 'id'].includes(event.target.name)) this.update();
          };
          document.addEventListener('input', onInput, { signal });
          document.addEventListener('change', onInput, { signal });
          this.form?.addEventListener('variant:change', () => this.update(), { signal });
          this.form?.addEventListener('product:rerender', (event) => {
            const nodes = event.detail?.htmlFragment?.querySelectorAll('amb-availability');
            const replacement = Array.from(nodes || []).find((node) => node.dataset.formId === this.dataset.formId);
            if (replacement) this.config = JSON.parse(replacement.querySelector('[data-availability]').textContent);
            this.update();
          }, { signal });
          this.update();
          refreshCart();
        });
      }

      disconnectedCallback() {
        controls.delete(this);
        this.abortController?.abort();
      }

      update() {
        if (!this.config || !this.message) return;
        const id = String(this.form?.elements.namedItem('id')?.value || this.dataset.variantId);
        const variant = this.config.variants[id];
        this.hidden = !variant?.eligible || !variant.available;
        if (this.hidden) return;
        const quantity = Math.max(1, Number(this.form?.elements.namedItem('quantity')?.value) || 1);
        const allocated = latestCart
          ? latestCart.items.filter((item) => String(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0)
          : id === this.dataset.variantId ? Number(this.dataset.allocated) : 0;
        const ready = Math.min(quantity, Math.max(0, variant.stock - allocated));
        const made = quantity - ready;
        const c = this.config;
        const lines = made === 0
          ? [`${c.inStock} ${c.dispatch}`]
          : ready > 0
            ? [`${c.mixedStock.replace('__COUNT__', ready)} ${c.dispatch}`, `${c.mixedMade.replace('__COUNT__', made)} ${c.production.replace(/^Made to order\. /, '')}`]
            : [c.production];
        const current = Array.from(this.message.childNodes, (node) => node.nodeName === 'BR' ? '\n' : node.textContent).join('');
        if (current !== lines.join('\n')) {
          this.message.replaceChildren(...lines.flatMap((line, index) => index === 0
            ? [document.createTextNode(line)]
            : [document.createElement('br'), document.createTextNode(line)]));
        }
      }
    }

    document.addEventListener('cart:change', (event) => updateCart(event.detail?.cart));
    document.addEventListener('cart:refresh', refreshCart);
    window.addEventListener('pageshow', refreshCart);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refreshCart();
    });
    if (!customElements.get('amb-availability')) customElements.define('amb-availability', AmbAvailability);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["amb-carousel-scrollbar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amb-collection-scrollbar')) {
  customElements.define('amb-collection-scrollbar', class extends HTMLElement {
    connectedCallback() {
      this.track = document.getElementById(this.getAttribute('aria-controls'));
      this.thumb = this.querySelector('.amb-collection-explore__scrollbar-thumb');
      if (!this.track || !this.thumb) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const ratio = this.track.scrollWidth ? Math.min(1, this.track.clientWidth / this.track.scrollWidth) : 1;
        const progress = max ? Math.min(1, Math.abs(this.track.scrollLeft) / max) : 0;
        this.thumb.style.width = ratio * 100 + '%';
        this.thumb.style.insetInlineStart = progress * (1 - ratio) * 100 + '%';
        this.setAttribute('aria-valuenow', Math.round(progress * 100));
        this.setAttribute('aria-disabled', String(max === 0));
        this.tabIndex = max ? 0 : -1;
      };
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.observer.observe(this);
      this.addEventListener('pointerdown', event => {
        if (event.button !== 0 || this.getAttribute('aria-disabled') === 'true') return;
        event.preventDefault();
        this.focus({ preventScroll: true });
        const thumbBounds = this.thumb.getBoundingClientRect();
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        const inThumb = event.clientX >= thumbBounds.left && event.clientX <= thumbBounds.right;
        this.dragOffset = inThumb ? (this.rtl ? thumbBounds.right - event.clientX : event.clientX - thumbBounds.left) : thumbBounds.width / 2;
        this.dragPointer = event.pointerId;
        this.previousSnap = this.track.style.scrollSnapType;
        this.track.style.scrollSnapType = 'none';
        this.setPointerCapture(event.pointerId);
        this.movePointer(event);
      }, options);
      this.addEventListener('pointermove', event => {
        if (event.pointerId === this.dragPointer) this.movePointer(event);
      }, options);
      const stopDragging = event => {
        if (event.pointerId !== this.dragPointer) return;
        this.dragPointer = null;
        this.track.style.scrollSnapType = this.previousSnap;
      };
      this.addEventListener('pointerup', stopDragging, options);
      this.addEventListener('pointercancel', stopDragging, options);
      this.addEventListener('lostpointercapture', stopDragging, options);
      this.addEventListener('keydown', event => {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const previous = rtl ? 'ArrowRight' : 'ArrowLeft';
        const next = rtl ? 'ArrowLeft' : 'ArrowRight';
        if (![previous, next, 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.track.select(0);
        else if (event.key === 'End') this.track.select(this.track.cells.length - 1);
        else if (event.key === previous || event.key === 'PageUp') this.track.previous();
        else this.track.next();
      }, options);
      this.update();
    }

    movePointer(event) {
      const bounds = this.getBoundingClientRect();
      const travel = bounds.width - this.thumb.getBoundingClientRect().width;
      const position = this.rtl ? bounds.right - event.clientX : event.clientX - bounds.left;
      const progress = travel > 0 ? Math.max(0, Math.min(1, (position - this.dragOffset) / travel)) : 0;
      const scroll = progress * (this.track.scrollWidth - this.track.clientWidth);
      this.track.scrollLeft = this.rtl ? -scroll : scroll;
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.dragPointer != null && this.track) this.track.style.scrollSnapType = this.previousSnap;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["amb-collection-browse"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amb-collection-browse')) {
    customElements.define('amb-collection-browse', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.querySelectorAll('details').forEach(detail => {
          detail.addEventListener('toggle', () => {
            if (detail.open) this.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
          }, options);
        });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closePanels();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const open = this.querySelector('details[open]');
          if (open) { open.open = false; open.querySelector('summary').focus(); event.preventDefault(); }
        }, options);
      }
      closePanels() { this.querySelectorAll('details[open]').forEach(detail => { detail.open = false; }); }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["amb-one-of-one-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const controls = new Set();
    let latestCart;
    let revision = 0;
    let pendingRefresh;

    function updateCart(cart) {
      if (!Array.isArray(cart?.items)) return;
      latestCart = cart;
      revision += 1;
      controls.forEach((control) => control.update(cart));
    }

    async function refreshCart() {
      if (!controls.size || pendingRefresh) return pendingRefresh;
      const startedAt = revision;
      pendingRefresh = (async () => {
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          if (revision === startedAt) updateCart(cart);
        } catch {
          // Keep the last known state if the cart cannot be reached.
        } finally {
          pendingRefresh = undefined;
        }
      })();
      return pendingRefresh;
    }

    class AmbOneOfOneCart extends HTMLElement {
      connectedCallback() {
        controls.add(this);
        this.inCart = this.dataset.inCart === 'true';
        this.abortController = new AbortController();
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.button = this.parentElement.querySelector('button[type="submit"]');
          this.update(latestCart);
          this.button?.form?.addEventListener('submit', (event) => {
            if (!this.inCart) return;
            event.preventDefault();
            event.stopImmediatePropagation();
          }, { capture: true, signal: this.abortController.signal });
          // Quick-buy markup may have been fetched before the latest cart change.
          refreshCart();
        });
      }

      disconnectedCallback() {
        controls.delete(this);
        this.abortController?.abort();
      }

      update(cart) {
        if (cart) {
          this.inCart = cart.items.some((item) => String(item.variant_id) === this.dataset.variantId && item.quantity > 0);
        }
        if (!this.button) return;
        this.button.disabled = this.inCart || this.dataset.unavailable === 'true';
        this.button.textContent = this.inCart ? this.dataset.cartLabel : this.dataset.buttonLabel;
        this.parentElement.toggleAttribute('data-amb-in-cart', this.inCart);
      }
    }

    document.addEventListener('cart:change', (event) => updateCart(event.detail?.cart));
    document.addEventListener('cart:refresh', refreshCart);
    window.addEventListener('pageshow', refreshCart);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refreshCart();
    });
    if (!customElements.get('amb-one-of-one-cart')) {
      customElements.define('amb-one-of-one-cart', AmbOneOfOneCart);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["amb-similar-items"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amb-similar-products')) {
    customElements.define('amb-similar-products', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const header = this.querySelector('.amb-similar-products__header');
        const carousel = this.querySelector('scroll-carousel');
        const panel = this.querySelector('[data-panel]');
        const controls = this.querySelector('[data-controls]');
        const count = this.querySelector('[data-count]');
        const toggles = this.querySelectorAll('[data-toggle]');
        const counter = this.querySelector('[data-counter]');
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const total = carousel?.children.length || 0;
        let index = carousel?.selectedIndex || 0;
        const update = (selectedIndex) => {
          if (panel.hidden) return;
          index = selectedIndex;
          if (counter) {
            counter.textContent = `${index + 1}/${total}`;
            counter.setAttribute('aria-label', counter.dataset.label.replace('[index]', index + 1));
          }
          if (previous) previous.disabled = index === 0;
          if (next) next.disabled = index === total - 1;
        };
        header.addEventListener('click', (event) => {
          if (event.target.closest('a, [data-previous], [data-next]')) return;
          const expanded = panel.hidden;
          const retainedIndex = index;
          panel.hidden = !expanded;
          if (controls) controls.hidden = !expanded;
          if (count) count.hidden = expanded && total > 0;
          this.dataset.expanded = String(expanded);
          toggles.forEach((button) => button.setAttribute('aria-expanded', String(expanded)));
          if (expanded && carousel) {
            requestAnimationFrame(() => {
              if (this.isConnected && !panel.hidden) carousel.select?.(retainedIndex, { instant: true });
            });
          }
        }, options);
        previous?.addEventListener('click', () => carousel.previous?.(), options);
        next?.addEventListener('click', () => carousel.next?.(), options);
        carousel?.addEventListener('carousel:change', (event) => update(event.detail.index), options);
        carousel?.addEventListener('keydown', (event) => {
          if (event.target !== carousel) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            if (event.key === 'ArrowLeft') carousel.previous?.();
            else carousel.next?.();
          }
        }, options);
        update(index);
      }
      disconnectedCallback() {
        this.abortController.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
